import type { FC } from 'react';
import { useCallback, useState } from 'react';
import API from '@api';
import { validationPhone } from '@utils/validation';
import { observer } from 'mobx-react';
import { Modal, OldInput } from '@ui';
import { Link } from '@compat/router';
import { useStores } from '@root/src/stores';
import './index.scss';

interface CallbackModalProps {
  changeToSuccessModal: () => void;
  onClose: () => void;
}

const CallbackModal: FC<CallbackModalProps> = observer(
  ({ changeToSuccessModal, onClose }) => {
    const { userStore } = useStores();
    const [phone, setPhone] = useState({
      value: userStore?.user?.phone || '',
      error: ''
    });
    const [text, setText] = useState({
      value: userStore?.user?.fio || '',
      error: ''
    });

    const onSubmit = useCallback(() => {
      let error = '';

      if (!validationPhone(phone.value)) {
        error = 'Номер введен неверно!';
      }

      if (phone.value?.length === 0) {
        error = 'Вы ничего не ввели';
      }

      setPhone(prev => ({ ...prev, error }));

      if (error) {
        return;
      }

      API.callback({ phone: phone.value, fio: text.value }).then(res => {
        res && changeToSuccessModal();
      });
    }, [changeToSuccessModal, phone.value, text.value]);

    const getInputData = useCallback(({ name, value }) => {
      if (name === 'phone') {
        setPhone(prev => ({ ...prev, value }));
      }
      if (name === 'text') {
        setText(prev => ({ ...prev, value }));
      }
    }, []);

    return (
      <Modal framed placementMobile='bottom-sheet' onClose={onClose}>
        <div className='CallbackModal'>
          <div className='CallbackModal__title'>
            Заказать <br /> обратный звонок
          </div>
          <div className='CallbackModal__desc'>
            Ответим на любые вопросы о товаре, доставке, возврате и гарантиях.
          </div>

          <OldInput
            field='phone'
            name='phone'
            placeholder='Ваш номер телефона'
            value={phone.value}
            getInputData={getInputData}
            className='CallbackModal__phone-input'
            error={phone.error}
          />

          <OldInput
            field='text'
            name='text'
            placeholder='Ваше имя'
            value={text.value}
            getInputData={getInputData}
            error={text.error}
            className='CallbackModal__name-input'
          />

          <button className={'CallbackModal__btn'} onClick={onSubmit}>
            Позвоните мне
          </button>
          <div className='CallbackModal__policy'>
            Нажимая кнопку «Позвоните мне»,
            <br />
            вы принимаете условия{' '}
            <Link
              className='CallbackModal__policy-link'
              to='/license-agreement'
              target='_blank'
              rel='noopener noreferrer'
            >
              Пользовательского соглашения
            </Link>{' '}
            и{' '}
            <Link
              className='CallbackModal__policy-link'
              to='/confidential'
              target='_blank'
              rel='noopener noreferrer'
            >
              Политики конфиденциальности
            </Link>
            и даете{' '}
            <Link
              className='CallbackModal__policy-link'
              to='/pdn'
              target='_blank'
              rel='noopener noreferrer'
            >
              Согласие на обработку персональных данных
            </Link>
          </div>
        </div>
      </Modal>
    );
  }
);

export default CallbackModal;
